import { Action, createReducer, on } from '@ngrx/store';
import * as WindowDetailActions from '../actions/window-detail.actions'

export const windowDetailFeatureKey = 'windowDetail';

export interface State {
  documentHeight:number
  documentWidth:number
}

export const initialState: State = {
  documentHeight : 0,
  documentWidth : 0
};


export const reducer = createReducer(
  initialState,

  on(WindowDetailActions.setDocumentSize,(state,action)=>{
    return{
      ...state,
      documentHeight:action.documentHeight,
      documentWidth:action.documentWidth
    }
  })  
);

